export const environment = {
  envName: 'HML',
  production: true,
  firebase: {
    apiKey: "AIzaSyBP-1mhesHd2lCyoeQlVwzyDTavL0rVTm4",
    authDomain: "aden-bank-hml.firebaseapp.com",
    projectId: "aden-bank-hml",
    storageBucket: "aden-bank-hml.appspot.com",
    messagingSenderId: "640072087097",
    appId: "1:640072087097:web:c1b0ef983661ff9f047fe8"
  },

  tenants: [
    {
      tenant: "aden-bank-hml-nrfda",
      name: "adenbank",
      primaryColor: "#01352E",
      overPrimary: "#000000",
      icon: "https://storage.googleapis.com/aden-bank-hml.appspot.com/tenant-assets/aden-bank/icon",
      apiKey: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJEaWxldHRhIFNvbHV0aW9ucyIsImlhdCI6MTc1NTAwMjM3MDY2NywiYXVkIjoiYWRlbi1iYW5rLWhtbCIsInN1YiI6ImFkZW4tYmFuay1obWwiLCJqdGkiOiJjMGYzMDMyZC01Zjk2LTRhM2YtYjUwYS1hNTJhZDljZWY1YmUiLCJ0ZW5hbnRJZCI6ImFkZW4tYmFuay1obWwtbnJmZGEifQ.1pCRC1xUus6AZj7MXdDteIOc7shmWgvCjDLneprW5qUxXPcUeiPymdjHk6ke3AgpwRflfN9M--20PGXAplvTUA",
      client: "matera",
      clientSuite: true,
      infoHeader: false,
      biz: false,
      apiUrl: 'https://api.adenbank-hml.dilettapay.app',
      formattedName: "Aden Bank HML",
      logo: "https://storage.googleapis.com/aden-bank-hml.appspot.com/tenant-assets/aden-bank/logo",
      logoLogin: "https://storage.googleapis.com/aden-bank-hml.appspot.com/tenant-assets/aden-bank/logo",
      minimalLogin: false
    }
  ],
  apiUrl: 'https://api.adenbank-hml.dilettapay.app',
  keyEncryptAuth: 'oGTy7QtyHr48GE6re5KTckkGnbm6oo7SwRHsi2gqjapqflY9hjTAJ4GyUtt9YrSK',
  apiUrlFunctions: 'https://us-central1-aden-bank-hml.cloudfunctions.net',
  account: '413453',
  branch: '3100',
  wallet: '109',
  bank: '341',
  currency: '9'
}